module.exports = __webpack_public_path__ + "img/bee-img-auth-sideimg1.02bad2b3.png";